import * as React from "react";
import { PropertyImportantInfo as SharedUiPropertyImportantInfo } from "@shared-ui/lodging-property-details";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyImportantInfo = PropertyBexApiWrapper(SharedUiPropertyImportantInfo);

export const PropertyImportantInfo: React.FC<ComponentProps> = ({ context }) => (
  <UitkSpacing margin={{ block: "three" }}>
    <section>
      <WrappedPropertyImportantInfo context={context} />
    </section>
  </UitkSpacing>
);

export default PropertyImportantInfo;
